import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@/components/Button';
import BaseInput from '@/components_v2/inputs/BaseInput';
import { useTheme } from '@/hooks/theme';
import { Container, ButtonsContainer, Title } from './styles';

interface SaveFavoriteModalProps {
  onSave: (name: string) => void | Promise<void>;
  onCancel: () => void;
  isLoading?: boolean;
}

const SaveFavoriteModal: React.FC<SaveFavoriteModalProps> = ({
  onSave,
  onCancel,
  isLoading: externalLoading,
}) => {
  const { t } = useTranslation();
  const { colors } = useTheme();
  const [name, setName] = useState('');
  const [localLoading, setLocalLoading] = useState(false);

  const isLoading = externalLoading || localLoading;

  const handleSave = async () => {
    if (!name.trim() || isLoading) return;
    setLocalLoading(true);
    try {
      await onSave(name);
    } finally {
      setLocalLoading(false);
    }
  };

  return (
    <Container>
      <Title>{t('favorites.save_name_label', 'Nome do favorito')}</Title>
      <BaseInput
        autoFocus
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder={t('favorites.save_name_placeholder', 'Ex: Agendamento Semanal')}
        disabled={isLoading}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && name.trim() && !isLoading) {
            handleSave();
          }
        }}
      />
      <ButtonsContainer>
        <Button
          text={t('buttons.cancel')}
          callback={onCancel}
          type="GREY_BACKGOUND"
          style={{ marginRight: 10, border: 'none' }}
          disabled={isLoading}
        />
        <Button
          text={t('buttons.save')}
          callback={handleSave}
          type="PRIMARY_BACKGROUND"
          style={{ backgroundColor: colors.primary, border: 'none' }}
          disabled={!name.trim() || isLoading}
          isLoading={isLoading}
        />
      </ButtonsContainer>
    </Container>
  );
};

export default SaveFavoriteModal;
